import React, { useEffect, useState } from "react";
import api, { formatErr } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Switch } from "../../components/ui/switch";
import { toast } from "sonner";

export default function AdminFestival() {
  const [cfg, setCfg] = useState({ enabled: false, title: "", badge: "Limited Time", package_slugs: [] });
  const [pkgs, setPkgs] = useState([]);

  useEffect(() => {
    api.get("/festival").then((r) => setCfg(prev => ({ ...prev, ...r.data })));
    api.get("/packages?limit=500").then((r) => setPkgs(r.data));
  }, []);

  const togglePkg = (slug) => {
    setCfg((c) => ({ ...c, package_slugs: c.package_slugs.includes(slug) ? c.package_slugs.filter((s) => s !== slug) : [...c.package_slugs, slug] }));
  };

  const save = async () => {
    try {
      await api.put("/admin/festival", { enabled: cfg.enabled, title: cfg.title, badge: cfg.badge, package_slugs: cfg.package_slugs });
      toast.success("Festival config saved");
    } catch (err) { toast.error(formatErr(err)); }
  };

  return (
    <div data-testid="admin-festival">
      <h1 className="font-serif-display text-4xl mb-8">Festival Control</h1>
      <div className="bg-background rounded-2xl border border-border p-6 space-y-4 max-w-2xl">
        <div className="flex items-center justify-between">
          <Label>Enable Festival Section</Label>
          <Switch checked={cfg.enabled} onCheckedChange={(v) => setCfg({ ...cfg, enabled: v })} data-testid="festival-toggle" />
        </div>
        <div><Label>Title</Label><Input value={cfg.title} onChange={(e) => setCfg({ ...cfg, title: e.target.value })} data-testid="festival-title" /></div>
        <div><Label>Badge Text</Label><Input value={cfg.badge} onChange={(e) => setCfg({ ...cfg, badge: e.target.value })} /></div>
        <div>
          <Label>Featured Packages</Label>
          <div className="grid sm:grid-cols-2 gap-2 max-h-80 overflow-y-auto mt-2">
            {pkgs.map((p) => (
              <label key={p.slug} className="flex items-center gap-2 p-2 bg-muted rounded text-sm cursor-pointer">
                <input type="checkbox" checked={cfg.package_slugs.includes(p.slug)} onChange={() => togglePkg(p.slug)} className="accent-primary" />
                {p.title}
              </label>
            ))}
          </div>
        </div>
        <Button onClick={save} className="rounded-full bg-primary" data-testid="festival-save">Save</Button>
      </div>
    </div>
  );
}
